export const ICON_MAP_WITH_ROUND = {
    'google+': 'icon-google2',
    snapchat: 'snapchat-logo',
    twitter: 'icon-newtwitter-round',
    instagram: 'instagram-logo',
    angelist: 'icon-angellist-round',
    whatsapp: 'icon-agent-whatsapp',
    youtube: 'icon-youtube-fill',
    tiktok: 'icon-tik-tok'
};
export const ICON_MAP_WITH_SQUARE = {
    'google+': 'icon-google2',
    whatsapp: 'icon-whatsapp',
    angelist: 'icon-angelist',
    redfin: 'icon-redfin',
    twitter: 'icon-newtwitter-square',
    instagram: 'instagram-logo',
    snapchat: 'snapchat-logo',
    youtube: 'icon-youtube-fill2',
    tiktok: 'icon-tik-tok'
};
export const ICON_MAP_WITH_AGENT = {
    'google+': 'icon-google-sign',
    whatsapp: 'icon-agent-whatsapp',
    redfin: 'icon-redfin-simple',
    angelist: 'icon-angelist-square',
    twitter: 'icon-newagent-twitter',
    instagram: 'icon-instagram',
    snapchat: 'icon-snapchat',
    youtube: 'icon-youtube1',
    tiktok: 'icon-tik-tok'
};
export const ICON_MAP_WITH_FACEBOOK = {
    facebook: 'icon-facebook',
    'google+': 'icon-google2',
    whatsapp: 'icon-whatsapp',
    angelist: 'icon-angelist',
    redfin: 'icon-redfin',
    twitter: 'icon-newtwitter-square',
    instagram: 'instagram-logo',
    snapchat: 'snapchat-logo',
    youtube: 'icon-youtube-fill2',
    tiktok: 'icon-tik-tok'
};
